<template>
  <ItemsWaiting style="position: absolute;right: -1vw !important;top: 3vw;z-index: -1;" v-if="is_fetch" />
  <div v-else>
    <div class="d-flex justify-content-between" v-if="allItems.length">
      <div class="text-right m-4">
        <h5 style="font-size: 1vw !important"></h5>
      </div>
      <div class="d-flex" v-if="allItems.length">
        <a   style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1" v-if="seconder_ban || approver_ban" v-show="!status_show" @click="infoCancelledModal=true">   دلایل عدم تایید</a>






      </div>

    </div>
    <center v-if="status_approver">
      <div   class="alert alert-success w-25">
        تایید نهایی!
      </div>
    </center>
    <center v-if="!status_show && allItems.length">

      <div v-if="seconder_ban"  class="alert alert-warning w-50" @click="infoCancelledModal=true" >
        <div v-if="this.$cookies.isKey('type_2')">
          کاربرگ توسط مدیر عامل تایید نشد!
        </div>
        <div v-else>
          این کاربرگ قبلا توسط شما رد شده است و الان اصلاح شده است!

        </div>
      </div>
    </center>
    <center v-if="!status_show">
      <div v-if="approver_ban" @click="infoCancelledModal=true"  class="alert alert-info" style="width: 30vw;">
        کاربرگ توسط دبیر کمسیون بهره وری ؛ تایید نشد!
      </div>
    </center>
    <center   v-if="status_seconder_step">
      <div v-if="status_seconder" class="alert alert-info w-25">
        در انتظار تایید توسط مدیر عامل
      </div>
      <div v-if="!status_seconder" class="alert alert-info" style="width: 24vw;">
        در انتظار تایید توسط دبیر کمسیون بهره وری
      </div>
    </center>
    <div class="table-responsive p-5" style="overflow-x:scroll; ">
      <center v-show="!allItems.length">
        <span v-if="$cookies.isKey('type_2') && isWrite">پایش و مراقبت  بهره وری وجود ندارد</span>
        <span v-else-if="!isWrite">دوره ای برای  پایش بهره وری این شرکت فعال نمی باشد
</span>
        <span v-else>
            در انتظار تکمیل کاربرگ توسط دبیرکمیته بهره وری
          </span>
      </center>
      
      <div style="overflow-y: scroll; height: 30vw;" >
        <table class="table table-striped" v-show="allItems.length" style="width: 240vw; ">
          <tbody>
          <tr style="height: 1vw !important;">
            <th class="sticky-header">
              <br>
              <strong >ردیف</strong></th>
            <th class="sticky-header" style="width: 12vw;">
              <br>
              <strong>مسئله</strong></th>
            <th class="sticky-header"><strong>
              <br>

              سیاست مداخله</strong></th>
            <th class="sticky-header" style="width: 7vw;"><br><strong>اقدام پیشران  </strong></th>
            <th class="sticky-header" style="width: 7vw;"><br><strong> زمان شروع اقدام </strong></th>
            <th class="sticky-header" style="width: 7vw;"><br><strong> زمان پایان اقدام </strong></th>
            <th class="sticky-header" style="width: 37vw;"><br><strong> عنوان  سنجه اقدام</strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> هدف  سنجه   بهار 1403 </strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> عملکرد   سنجه  بهار 1403 </strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> درصد تحقق سنجه  بهار 1403 </strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> هدف  سنجه   تابستان 1403 </strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> عملکرد   سنجه  تابستان 1403 </strong></th>
            <th class="sticky-header" style="width: 6vw;"><br><strong> درصد تحقق سنجه  تابستان 1403 </strong></th>
            <th class="sticky-header" style="width: 7vw;"><br><strong> فعالیت‌ کلیدی </strong></th>
            <th class="sticky-header" style="width: 7vw;"><br><strong> دستگاه‌ همکار </strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>تاریخ شروع فعالیت</strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>تاریخ پایان فعالیت</strong></th>
            <th class="sticky-header" style="width: 5vw;"><strong>مستندات پیشرفت فعالیت‌ها </strong></th>
            <th class="sticky-header"><strong>   هدف  بهار 1403  </strong></th>
            <th class="sticky-header"><strong>  میزان پیشرفت  بهار 1403    </strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف بهار 1403 </strong></th>
            <th class="sticky-header"><strong>   هدف  تابستان 1403   </strong></th>
            <th class="sticky-header"><strong>  میزان پیشرفت  تابستان 1403  </strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف تابستان 1403   </strong></th>
            <th class="sticky-header"><strong><br>مهم‌ترین موانع عدم تحقق برنامه </strong></th>
            <th class="sticky-header"><strong><br>راهکار پیشنهادی </strong></th>
          </tr>

          <tr class="bg-white" v-for="(item, index) in sortedItems" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.problem && item.problem.title }}</td>
            <td>{{ item.problem && item.problem.basic_measures_problem && item.problem.basic_measures_problem.intervention_policy }}</td>
            <td>{{ item.propulsion_basic_action && item.propulsion_basic_action.title }}</td>
            <td>{{ item.propulsion_basic_action && item.propulsion_basic_action.date_start }}</td>
            <td>{{ item.propulsion_basic_action && item.propulsion_basic_action.date_end }}</td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td :title="result.trustee_device">
                    {{ result.trustee_device.length > 50 ? result.trustee_device.slice(0, 80) + '...' : result.trustee_device }}
                  </td>
                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td >
                    <span v-if="parseInt(result.goal_spring)!==0">{{result.goal_spring??computeProgressForSameId(item.propulsion_basic_actions_id)  }}</span>

                    <span v-else>0</span>
                  </td>

                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td v-if="result.nature_type === 1">{{computeProgressForSameIdV2(item.propulsion_basic_actions_id)}}</td>
                  <td v-else>
                    <input @input="updateValue(result, $event.target.value, 'spring')"
                           :value="result.value_per_yes" :id="`num_first_${result.id}`" type="text"
                           class="form-control text-center" style="height: 1.4vw;">
                  </td>
                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td v-if="result.nature_type === 2">{{ calculateSpringProgress(result) }}</td>
                  <td v-if="result.nature_type === 1">{{ (Math.floor(computeProgressForSameIdV2(item.propulsion_basic_actions_id)/((computeProgressForSameId(item.propulsion_basic_actions_id))) * 100) / 100).toFixed(2)??0}}</td>
                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td>{{result.goal_summer ?? computeProgressForSameIdSummer(item.propulsion_basic_actions_id)}}</td>
                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td v-if="result.nature_type === 1">{{computeProgressForSameIdSummerV2(item.propulsion_basic_actions_id)}}</td>
                  <td v-else>
                    <input :id="`num_second_${result.id}`" @input="updateValue(result, $event.target.value, 'summer')"
                           :value="result.value_second_per_yes" type="text" class="form-control text-center" style="height: 1.4vw;">
                  </td>
                </tr>
              </table>
            </td>

            <td style="padding: 0;border-left: unset !important;">
              <table v-if="shouldShowTrusteeActions(index, item)" style="border: unset !important; border-left: unset !important;border-right: unset !important" class="w-100">
                <tr v-if="item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions"
                    v-for="result in item.propulsion_basic_action.trustee_actions" :key="result.id"
                    class="w-100" style="border: unset !important; border-left: unset !important;border-right: unset !important">
                  <td v-if="result.nature_type === 2">{{ calculateSummerProgress(result) }}</td>
                  <td v-if="result.nature_type === 1">{{(Math.floor(computeProgressForSameIdSummerV2(item.propulsion_basic_actions_id)/(computeProgressForSameIdSummer(item.propulsion_basic_actions_id)) * 100) / 100).toFixed(2)}}
                    </td>
                </tr>
              </table>
            </td>

            <td>{{ item.title }}</td>
            <td>{{ item.partner_device }}</td>
            <td>{{ item && item.start_date }}</td>
            <td>{{ item && item.end_date }}</td>

            <td>
              <div class="d-flex align-items-center justify-content-center">
                <button @click.prevent="addDoc(item.title, item.id)" class="btn btn-primary btn-submit-1">تکمیل/بروزرسانی</button>
              </div>
            </td>

            <td style="width: 7vw;">
              {{item.expected_progress_spring}}
            </td>

            <td style="width: 7vw;">
              <input style="text-align: center"
                     @keyup="calculatedValue(item.id, item.expected_progress_spring)"
                     :value="item.device_monitoring && item.device_monitoring.summer_progress"
                     :id="`inputOne_${item.id}`" type="text" class="form-control">
            </td>

            <td style="width: 7vw;">
      <span :id="`result_one_${item.id}`">
        {{Math.max(0, (item.expected_progress_spring) - (item.device_monitoring && item.device_monitoring.summer_progress)).toFixed(2)}}
      </span>
            </td>

            <td style="width: 7vw;">
              {{item.expected_progress_summer}}
            </td>

            <td style="width: 7vw;">
              <input style="text-align: center"
                     @keyup="calculatedValueTwo(item.id, item.expected_progress_summer)"
                     :value="item.device_monitoring && item.device_monitoring.summer_funds"
                     :id="`inputTwo_${item.id}`" type="text" class="form-control">
            </td>

            <td style="width: 7vw;">
      <span :id="`result_two_${item.id}`">
        {{Math.max(0,item.expected_progress_summer - (item.device_monitoring && item.device_monitoring.summer_funds)).toFixed(2)}}
      </span>
            </td>

            <td>
              <textarea
                         :id="`inputNine_${item.id}`" type="text" class="form-control" cols="30" rows="10">{{item.device_monitoring && item.device_monitoring.important_obstacles}}</textarea>
            </td>

            <td>

              <textarea
                         :id="`inputTen_${item.id}`" type="text" class="form-control" cols="30" rows="10">{{item.device_monitoring && item.device_monitoring.approach}}</textarea>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <br>
      <hr v-if="allItems.length">
      <center v-if="show_insert" v-show="allItems.length">
        <button @click.prevent="store" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>
      </center>
      <div v-if="allItems.length" class="d-flex align-items-center justify-content-center">
        <a v-if="allItems.length" :href="`${this.download_url}/KeyActivitiesProblem/all/word/${id_user}?token=${$cookies.get('id_login')}`" style="margin-top: 1.3vw;margin-left: 1vw;"
           class="btn btn-primary btn-submit-1">خروجی Word</a>
        <p @click.prevent="exportDocs"   style="margin-left: 1vw;margin-top: 2.5vw;"
           class="btn btn-primary btn-submit-1">خروجی مستندات</p>

        <a
            :style="$cookies.isKey('type_2') ? 'width: 10vw': ''"
            style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green" class="btn btn-primary btn-submit-1 "


        >
          <div v-if="!status_loading">

            <span  @click="acceptComplete" v-if="!$cookies.isKey('type_2')">  تایید </span>
            <span  @click="acceptCompleteModal=true" v-else>    ارائه جهت تایید مدیرعامل</span>

          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
        <div dir="rtl" class="modal__error slide-top" v-show="acceptCompleteModal" style="z-index: 999999999999999; top: 40%;">
          <div>
            <p>اخطار</p>
            <p @click="acceptCompleteModal=!acceptCompleteModal">❌</p>
          </div>
          <div>
            <p>آیا از ارائه به مدیرعامل مطمئن هستید؟</p>

            <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
              <button @click="acceptCompleteModal=!acceptCompleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
              <button class="btn btn-primary btn-approve" @click="acceptComplete">تایید</button>
            </div>
          </div>
        </div>
        <a v-if="!$cookies.isKey('type_2')"   style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  " class="btn btn-primary btn-submit-1 "
           @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span >عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>
    </div>

    <div class="modal__error bg-white" style="z-index: 9699; width: 54vw; overflow-y: scroll; height: 35vw;" v-show="documentsModal">
      <div class="d-flex justify-content-between">
        <p>{{titleDoc}}</p>
        <p id="btn2_p" @click.prevent="exitModal">❌</p>
      </div>
      <hr>
      <div class="d-flex flex-column" v-if="show_insert">
        <label class="required text-end">     عنوان مستندات پیوست  </label>
        <input id="title" v-model="title_attach" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column" v-if="show_insert">
        <label class="required text-end">      فایل   پیوست  </label>
        <label class="input input--file">

          <input  id="file" type="file" class="input__field" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv" required>
          <span class="input__support">
    <span class="input__helper"></span>
    </span>
        </label>
      </div>

      <div id="showBar" style="display:none;">
        <div class="progress">
          <div class="progress-bar" role="progressbar" id="progress_bar"  :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <p id="progress"></p>
      </div>
      <center class="my-2" v-if="show_insert">
        <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن </button>
        <hr class="my-3 w-100" v-if="show_insert">
      </center>
      <div v-if="!documents.length">موردی یافت نشد!</div>
      <table  class="table table-striped bg-white" v-if="documents.length">
        <thead >
        <tr>
          <th ><strong> عنوان مستند    </strong></th>
          <th><strong>فایل مستند</strong></th>
          <th v-if="show_insert" style="width: 1vw;"><strong>عملیات  </strong></th>
        </tr>
        </thead>
        <tbody>

        <tr class="bg-white" v-for="(item) in documents">
          <td>{{item.title}}</td>
          <td>
            <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
          </td>
          <td v-if="show_insert">
            <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;"   href="#"><img  class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

          </td>
        </tr>
        </tbody>


      </table>
    </div>

    <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="importModal">
      <div class="d-flex flex-row justify-content-between">
        <p>درون ریزی</p>
        <p @click="importModal=!importModal">❌</p>
      </div>
      <div style="border: 1px solid #777; padding: 1vw; border-radius: 1vw">
        <input ref="fileInputTwo"  type="file" class="form-control" style="display:block;" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
        <div class="d-flex align-items-center justify-content-center">
          <button @click.prevent="importExcel" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>

        </div>
      </div>

    </div>

    <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
      <div class="d-flex justify-content-between w-100">
        <p>حذف</p>
        <p @click="delete_fileModal=!delete_fileModal">❌</p>
      </div>
      <div>
        <p>آیا میخواهید حذف کنید!</p>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
        </div>
      </div>
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>عدم تایید</p>
        <p @click="infoCancelled=!infoCancelled">❌</p>
      </div>
      <div>
        <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
        <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
        </div>
      </div>
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="infoCancelledModal" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>دلایل عدم تایید</p>
        <p @click="infoCancelledModal=!infoCancelledModal">❌</p>
      </div>
      <div>
        <div class="bg-white p-3 rounded w-100 text-right">
          <p>{{textAlert}}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
        </div>
      </div>
    </div>

    <div dir="rtl" class="modal__error slide-top" v-show="showReSubmit" style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>آیا مطمئن هستید تمامی موارد مشکل دار را رفع کرده اید؟</p>
        <p @click="showReSubmit=!showReSubmit">❌</p>
      </div>
      <div>
        <div class="bg-white p-3 rounded w-100 text-right">
          <p>{{textAlert}}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="showReSubmit=false"  class="btn btn-primary btn-back" type="submit">برگشت</button>
          <button @click="acceptComplete4"  class="btn btn-primary btn-submit-1" type="submit">تایید نهایی</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";
import ItemsWaiting from "@/components/Loaders/ItemsWaiting.vue";

const toast = useToast();

export default {
  components: {ItemsWaiting, Vue3PersianDatetimePicker},
  data() {
    return {
      is_fetch: true,
      status_loading2: false,
      showReSubmit: false,
      acceptCompleteModal: false,

      importModal: false,
      documentsModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      documents: [],
      id: '',
      result_one: '',
      result_Two: '',
      title: '',
      titleDoc: '',
      title_attach: '',
      file: '',
      id_two: '',

      target: '',

      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      key_activities_problems_id: '',
      spring_progress: '',
      summer_progress: '',
      autumn_progress: '',
      winter_progress: '',
      progress: 0,
      deviation: '',
      important_obstacles: '',
      approach: '',
      year_funds: '',
      spring_funds: '',
      summer_funds: '',
      autumn_funds: '',
      event: '',
      winter_funds: '',
      id_user: '',
      id_file: '',
      delete_fileModal: false,
      isWrite: false,
      status_show: false,
      status_loading: false,
      show_insert: false,
      status_seconder: false,
      status_approver: false,
      infoCancelled: false,
      text_info: '',
      seconder_ban: false,
      approver_ban: false,
      textAlert: '',
      infoCancelledModal: false,
      status_seconder_step: false,

    }
  },
  methods: {
    shouldShowTrusteeActions(index, item) {
      return index === 0 ||
          (this.sortedItems[index - 1] &&
              this.sortedItems[index - 1].propulsion_basic_action &&
              item.propulsion_basic_action &&
              this.sortedItems[index - 1].propulsion_basic_action.id !== item.propulsion_basic_action.id);
    },
    updateValue(result, newValue, type) {
      if (type === 'spring') {
        result.value_per_yes = newValue;
      } else if (type === 'summer') {
        result.value_second_per_yes = newValue;
      }

      // به روز رسانی توابع محاسبه
      this.calculateSpringProgress(result);
      this.calculateSummerProgress(result);
    },
    calculateSpringProgress(result) {
      if (result.nature_type === 2) {
        return (parseFloat(result.value_per_yes) / (result.goal_spring || 1)).toFixed(2);
      }
      return '0.00'; // Return a string formatted with two decimal places
    },

    calculateSummerProgress(result) {
      if (result.nature_type === 2) {
        return (parseFloat(result.value_second_per_yes || 0) / (result.goal_summer || 1)).toFixed(2);
      }
      return '0.00'; // Return a string formatted with two decimal places
    },
    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    setShow(){
      if (this.$cookies.isKey('type_2')){
        if (this.status_show===false){
          this.show_insert = true
          return;
        }
        this.show_insert = true
      }
      this.show_insert = false
    },
    acceptComplete(){
      this.acceptCompleteModal = false

      if (this.status_show ){
        return;
      }
      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      if (this.seconder_ban || this.approver_ban){
        this.showReSubmit=true
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    acceptComplete4(){
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }
            this.infoCancelled = false
            this.showReSubmit = false

          })
          .catch();
    },
    acceptComplete2(){

      if (this.status_loading){
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''

            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3(){
      this.status_loading2 = true
      if (!this.status_show){
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info){
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/KeyActivitiesProblem/update_complete`, requestOptions)
            .then(response => response.json())
            .then(response => {


            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info){
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    deleteMethodFile(id){
      this.id_file = id
      this.delete_fileModal = true
    },
    deleteMethodFileSubmit(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message){
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    importExcel(){
      const file = this.$refs.fileInputTwo.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/import`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInputTwo.value = ''
            this.all()
            this.importModal=false

          })
          .catch();
    },
    allDocsMethod(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/total_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length=0
            response.all.forEach((item)=>{
              this.documents.push(item)
            })


          })
          .catch();
    },
   /* addDocs() {
      const file = this.$refs.fileInput.files[0];
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach);
      formdata.append('file', file);
      formdata.append('id', this.id);

      var progress = 0;

      // Create a new Request object
      var request = new Request(`${this.base_url}/DeviceMonitoringCareForProblem/save_doc`, {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      });

      // Fetch with the Request object
      fetch(request)
          .then(response => {
            // Listen to the progress event
            response.body.onprogress = onProgress;
            return response.json();
          })
          .then(response => {
            // Handle response
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success(response.message);
            this.$refs.fileInput.value = '';
            this.title_attach = '';
            this.allDocsMethod(this.id);
          })
          .catch(error => {
            console.error('Error:', error);
          });

      // Define onProgress function
      function onProgress(event) {
        if (event.lengthComputable) {
          progress = (event.loaded / event.total) * 100;
          // Update progress UI here
          // For example:
          document.getElementById("progress").innerText = `${progress}%`;
          console.log(`Upload Progress: ${progress}%`);
        }
      }
    },*/

    async addDocs() {
      try {
        const token = this.$cookies.get('token');
        const file = document.querySelector('#file').files[0];

        if (!file) {
          toast.error("Please select a file to upload.");
          return;
        }

        const formdata = new FormData();
        formdata.append('title', this.title_attach);
        formdata.append('file', file);
        formdata.append('id', this.id);

        // نمایش نوار پیشرفت و پنهان‌سازی دکمه‌ها
        document.getElementById("showBar").style.display = 'block';
        document.getElementById("btn2_p").style.visibility = 'hidden';
        document.getElementById("btn_p").style.visibility = 'hidden';

        // درخواست آپلود با استفاده از fetch API
        const response = await fetch(`${this.base_url}/DeviceMonitoringCareForProblem/save_doc`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formdata,
        });

        const result = await response.json();

        if (response.ok && !result.error) {
          toast.success(result.message);

          // پاکسازی فرم پس از آپلود موفق
          document.querySelector('#title').value = '';
          document.querySelector('#file').value = '';
          this.title_attach = '';

          // بازگرداندن دکمه‌ها به حالت اولیه و مخفی کردن نوار پیشرفت
          document.getElementById("showBar").style.display = 'none';
          document.getElementById("btn2_p").style.visibility = 'visible';
          document.getElementById("btn_p").style.visibility = 'visible';

          // فراخوانی متد allDocsMethod پس از آپلود موفق
          this.allDocsMethod(this.id);
        } else {
          toast.error(result.error || 'An error occurred during the upload.');
        }

      } catch (error) {
        console.error('Upload error:', error);
        toast.error('An unexpected error occurred.');
      }
    }
    ,


    addDoc(title,id){
      this.id=id
      this.titleDoc=title
      this.allDocsMethod(this.id)
      this.documentsModal=true
    },
    calculatedValue(id, expected_progress_spring = 0) {
      let result = 0;
      const one = parseFloat(document.querySelector(`#inputOne_${id}`).value);

      let calc = (expected_progress_spring ?? 0) - (isNaN(one) ? 0 : one);

      if (calc < 0) {
        result = 0;
      } else {
        result = calc;
      }

      // Ensure that the result is always a number before applying toFixed
      document.querySelector(`#result_one_${id}`).textContent = Number(result).toFixed(2);
    },

    calculatedValueTwo(id,expected_progress_spring=0) {
      let result = 0;
      const one = parseFloat(document.querySelector(`#inputTwo_${id}`).value);


      let calc = (expected_progress_spring ?? 0) - (isNaN(one) ? 0 : one);

      if (calc < 0) {
        result = 0;
      } else {
        result = calc;
      }

      // Format result to two decimal places
      document.querySelector(`#result_two_${id}`).textContent =  Number(result).toFixed(2);
    },






    all() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/all_monitoring`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.event = response.event
            this.status_seconder =false
            this.seconder_ban = false
            this.status_seconder_step = false
            this.approver_ban = false
            this.status_approver = false
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {

              this.allItems.push(item)

            })
            this.is_fetch = false

            this.setShow()
            if (!response.status_seconder){
              if (response.status){
                this.status_seconder = true
              }
            }
            if (!this.status_approver && this.$cookies.isKey('type_1')){
              this.status_seconder = false
            }
            if (response.status && !response.status_approver){
              this.status_seconder = true
            }
            if (response.seconder_ban){
              this.seconder_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }
            if (response.approver_ban){
              this.approver_ban = true
              this.textAlert = response.message??'موردی یافت نشد'
            }

            if (response.status_approver){
              this.status_approver = true
            }
            if (response.text_seconder){
              this.seconder_ban = true
              this.textAlert = response.text_seconder??'موردی یافت نشد'
            }
            if (parseInt(response.step)===1){
              this.status_seconder_step=true
              this.status_seconder=true
            }
            if (parseInt(response.step)===2){
              this.status_seconder_step=true
              this.status_seconder=false
            }  if (parseInt(response.step)===0){
              this.status_seconder_step=false

            }
            this.show_insert = response.status_insert
          })
          .catch();
    },
    store() {
      let obj = [];

        let trusteeActions = [];
      this.allItems.forEach((item) => {

        if (item.propulsion_basic_action && item.propulsion_basic_action.trustee_actions) {
          item.propulsion_basic_action.trustee_actions.forEach((result) => {
            const springProgress = document.getElementById(`num_first_${result.id}`) ? document.getElementById(`num_first_${result.id}`).value : 0;
            const summerProgress = document.getElementById(`num_second_${result.id}`) ? document.getElementById(`num_second_${result.id}`).value : 0;

            let trusteeRecord = {
              'trustee_action_id': result.id,
              'spring_progress': springProgress,
              'summer_progress': summerProgress,
            };

            trusteeActions.push(trusteeRecord);
          });
        }


        const inputOne = document.getElementById(`inputOne_${item.id}`) ? document.getElementById(`inputOne_${item.id}`).value : null;
        const inputTwo= document.getElementById(`inputTwo_${item.id}`) ? document.getElementById(`inputTwo_${item.id}`).value : null;
        const inputSeven = document.getElementById(`inputSeven_${item.id}`) ? document.getElementById(`inputSeven_${item.id}`).value : null;
        const inputNine = document.getElementById(`inputNine_${item.id}`) ? document.getElementById(`inputNine_${item.id}`).value : null;
        const inputTen = document.getElementById(`inputTen_${item.id}`) ? document.getElementById(`inputTen_${item.id}`).value : null;

        let record = {
          'key_id': item.id,
          'deviation': inputSeven,
          'important_obstacles': inputNine,
          'id': item.device_monitoring ? item.device_monitoring.id : null,
          'approach': inputTen,
          'summer_funds': inputTwo,
          'summer_progress': inputOne,
        };

        obj.push(record);
      });

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj));
      formdata.append('trusteeActions', JSON.stringify(trusteeActions));

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success(response.message);
            this.all()
          })
          .catch();
    },

    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    ProductivityPeriod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/ProductivityPeriod/check`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.status){
              this.isWrite = true
              return
            }else{
              this.isWrite = false
            }



          })
          .catch();
    },
    computeProgressForSameId(id) {
      // Filter items that have the same propulsion_basic_actions_id
      const filteredItems = this.allItems.filter(
          (item) => item.propulsion_basic_actions_id === id
      );

      // Calculate the sum of expected_progress_spring * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + (item.expected_progress_spring * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    },
    computeProgressForSameIdV2(id) {
      // Filter items that have the same propulsion_basic_actions_id
      const filteredItems = this.allItems.filter(
          (item) => item.propulsion_basic_actions_id === id
      );

      // Calculate the sum of expected_progress_spring * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + ((item.device_monitoring ? item.device_monitoring.summer_progress:0) * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    },

    computeProgressForSameIdSummer(id) {
      // Filter items that have the same propulsion_basic_actions_id
      const filteredItems = this.allItems.filter(
          (item) => item.propulsion_basic_actions_id === id
      );

      // Calculate the sum of expected_progress_summer * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + (item.expected_progress_summer * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    },
    computeProgressForSameIdSummerV2(id) {
      // Filter items that have the same propulsion_basic_actions_id
      const filteredItems = this.allItems.filter(
          (item) => item.propulsion_basic_actions_id === id
      );

      // Calculate the sum of expected_progress_summer * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + ((item.device_monitoring ? item.device_monitoring.summer_funds : 0) * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    },

    computeProgressForSameIdExpected_progress_fall(id) {
      // Filter items that have the same expected_progress_fall
      const filteredItems = this.allItems.filter(
          (item) => item.expected_progress_fall === id
      );

      // Calculate the sum of expected_progress_fall * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + (item.expected_progress_fall * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    },

    computeProgressForSameIdExpected_progress(id) {
      // Filter items that have the same expected_progress
      const filteredItems = this.allItems.filter(
          (item) => item.expected_progress === id
      );

      // Calculate the sum of expected_progress * weight / 100 for similar items
      const total = filteredItems.reduce((total, item) => {
        return total + (item.expected_progress * item.weight) / 100;
      }, 0);

      return total.toFixed(2); // Return formatted total
    }
  },
  computed:{
    sortedItems() {
      return [...this.allItems].sort((a, b) => {
        const titleA = (a.propulsion_basic_action && a.propulsion_basic_action.title) || '';
        const titleB = (b.propulsion_basic_action && b.propulsion_basic_action.title) || '';
        return titleA.localeCompare(titleB);
      });
    },
    exitModal(){
      this.documentsModal=!this.documentsModal
      this.all()

    },
  },

  mounted() {
    this.all()
    this.fetchItems()
    this.ProductivityPeriod()

  }
}
</script>
<style scoped>
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}
.input:hover .input__support {
  border-color: #9fa8b2;
}
.input:hover .input__support:before {
  color: #7d8a96;
}
.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}
.input__text sup {
  color: #fe4f3e;
  cursor: help;
}
.input .input__support:before {
  display: none;

}
.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__field:focus + .input__support {
  border-color: #037DE4;
}
.input__field:valid + .input__support {
  border-color: #3742FA;
}
.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}
.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}
.input__field:invalid + .input__support:before {
  content: "file_upload";
}
.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}
.input__support {
  display: flex !important;
  align-items: center;
}
.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}
.input--file {
  cursor: pointer;
}
.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}

</style>